/**
 * Dicionário de traduções para campos comuns na aplicação
 */
export const traducoes: Record<string, string> = {
  // Campos gerais
  'smoking': 'Tabagismo',
  'freeSoloProblem': 'Problema principal',
  'newPlan': 'Plano de tratamento',
  'newExames': 'Exames',
  'prazo': 'Prazo',
  'plano': 'Plano',
  'name': 'Nome',
  'value': 'Valor',
  'Data de Referencia': 'Data de Referência',
  'New_Conduta': 'Conduta',
  
  // Estados e valores
  'normal': 'Normal',
  'alterado': 'Alterado',
  'not_evaluated': 'Não avaliado',
  'Current every day smoker': 'Atualmente, fumante diário',
  'Current some day smoker': 'Atualmente, fumante alguns dias na semana',
  'Former smoker': 'Ex-fumante',
  'Never smoker': 'Nunca fumou',
  'Smoker, current status unknown': 'Estado tabagista atual desconhecido',
  'Unknown if ever smoked': 'Sem conhecimento se já fumou',
  'Heavy tobacco smoker': 'Fumante frequente',
  'Light tobacco smoker': 'Fumante eventual',
  
  // Estruturas específicas
  'anamnese': 'Anamnese',
  'chiefComplaint': 'Queixa principal',
  'currentIllnessHistory': 'História da doença atual',
  'pastPathologicalHistory': 'História patológica pregressa',
  'personalAndSocialHistory': 'História pessoal e social',
  'familyHistory': 'História familiar',
  
  // Exames
  'physicalExams': 'Exames Físicos',
  'general': 'Geral',
  'headAndNeck': 'Cabeça e pescoço',
  'cardiovascular': 'Ap  Cardiovascular',
  'abdominal': 'Ap  Abdominal',
  'respiratory': 'Ap  Respiratório',
  'urinary': 'Ap  urinário',
  'osteoarticular': 'Osteoarticular',
  'skinAndAppendages': 'Pele e fâneros',
  'extremities': 'Extremidades',
  'mucosa': 'Mucosas',
  
  // Dados antropométricos e sinais vitais
  'anthropometricData': 'Dados Objetivos',
  'weight': 'Peso',
  'height': 'Altura',
  'bodyWeight': 'Peso',
  'bodyHeight': 'Altura',
  'abdominalCircumference': 'Circunferência Abdominal',
  'headCircumference': 'Perímetro Encefálico',
  'alcoholConsumption': 'Consumo diário de álcool (ml)',
  'alcoholic': 'Consumo diário de álcool (ml)',
  'pressure': 'Pressão Arterial',
  'sistolic': 'Sistólica',
  'diastolic': 'Diastólica',
  'temperature': 'Temperatura',
  'respiratoryRate': 'Frequência Respiratória',
  'cardiacRate': 'Frequência Cardíaca',
  'glicemiaCapilar': 'Glicemia Capilar',
  'spo2': 'Saturação de Oxigênio (SpO2)',
  'pain': 'Dor',
  
  // Outros
  'date': 'Data',
  'Anthropometric': 'Dados Objetivos',
  'exams': 'Exames Físicos',
  
  // Prazos
  '1': 'Longo prazo',
  '2': 'Curto prazo'
};

/**
 * Mapeamento de chaves especiais para formatar de forma específica
 */
export const mapeamentoEspecial: Record<string, string> = {
  'Exames físicos': 'Exames Físicos',
  'Dados Antropométricos': 'Dados Objetivos'
};

/**
 * Campos que devem ser ignorados completamente
 */
export const camposIgnorados = new Set(['$isDayjsObject', '$L', 'en', 'pt-br']);

/**
 * Função para traduzir um campo
 */
export function traduzirCampo(campo: string): string {
  return traducoes[campo] || campo;
}

/**
 * Função para aplicar mapeamento especial em campos específicos
 */
export function aplicarMapeamentoEspecial(campo: string): string {
  return mapeamentoEspecial[campo] || campo;
}

/**
 * Função para verificar se um campo deve ser ignorado
 */
export function deveIgnorarCampo(campo: string): boolean {
  return camposIgnorados.has(campo) || campo.startsWith('$');
} 